<template>
    <div class="module">
        <b-row class="skeleton">
            <b-col v-if="isFull" md="3" class="content">
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="3" class="image" v-else-if="showImage">
                <div></div>
            </b-col>
            <b-col md="3" class="content">
                <div></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="3" class="content">
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="3" class="content">
                <div class="smaller"></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        styles: {
            type: String,
            default: ""
        },
        showImage: {
            type: Boolean,
            default: true
        },
        // will have 4 rows
        // either show image or full row
        isFull: {
            type: Boolean,
            default: false
        }
    }
};
</script>
